import { getFullUrl } from 'hubspot-url-utils';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
export const getContactPageUrl = (subjectId, objectTypeId) => {
  const subdomainPrefix = enviro.deployed() ? 'app' : 'local';
  const portalId = PortalIdParser.get() || '';
  return `${getFullUrl(subdomainPrefix)}/contacts/${portalId}/record/${objectTypeId}/${subjectId}`;
};